import { useCallback, useState } from 'react';

export default function useToggle(initialState = false): [boolean, () => void] {
  const [state, setState] = useState<boolean>(initialState);

  const toggle = useCallback(() => setState(value => !value), []);

  return [state, toggle];
}
